// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ================================
   ADMIN LOGIN PAGE - SPLIT LAYOUT
   ================================ */

:root {
    --orange-light: #FF9966;
    --orange-primary: #FF6B35;
    --orange-dark: #D84315;
    --orange-glow: rgba(255, 107, 53, 0.4);
    --bg-light: #FFF5F0;
    --card-bg: rgba(255, 255, 255, 0.95);
    --glass-border: rgba(255, 107, 53, 0.2);
}

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

.admin-login-page {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #FFF5F0;
    font-family: 'Outfit', sans-serif;
    padding: 20px;
}

.admin-login-container {
    display: flex;
    width: 100%;
    max-width: 1200px;
    background: #fff;
    border-radius: 32px;
    box-shadow: 0 30px 60px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    min-height: 700px;
}

/* ================================
   LEFT SIDE: VISUAL CAROUSEL
   ================================ */
.admin-login-visual {
    flex: 1 1;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    background: #000;
}

.carousel-track {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.carousel-slide {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    opacity: 0;
    transition: opacity 1s ease-in-out;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding: 60px;
    z-index: 1;
}

.carousel-slide.active {
    opacity: 1;
    z-index: 2;
}

.slide-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.2) 50%, rgba(0, 0, 0, 0.1) 100%);
    z-index: -1;
}

.slide-content {
    color: #fff;
    z-index: 3;
    animation: slideUp 0.8s ease-out;
}

@keyframes slideUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.slide-content h2 {
    font-size: 36px;
    font-weight: 700;
    margin-bottom: 12px;
    line-height: 1.2;
}

.slide-content p {
    font-size: 16px;
    opacity: 0.9;
    line-height: 1.6;
    max-width: 80%;
}

.carousel-indicators {
    position: absolute;
    bottom: 30px;
    right: 30px;
    display: flex;
    gap: 8px;
    z-index: 10;
}

.indicator {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.3);
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;
}

.indicator.active {
    background: #fff;
    width: 30px;
    border-radius: 10px;
}

/* ================================
   RIGHT SIDE: LOGIN FORM
   ================================ */
.admin-login-form-container {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 60px;
    background: #fff;
    position: relative;
}

.admin-login-card {
    width: 100%;
    max-width: 420px;
}

.admin-login-logo {
    display: flex;
    justify-content: center;
    margin-bottom: 24px;
}

.admin-login-logo img {
    height: 60px;
    width: auto;
}

.admin-login-header {
    text-align: center;
    margin-bottom: 30px;
}

.admin-page-title {
    font-size: 28px;
    font-weight: 700;
    color: #2D2D2D;
    margin-bottom: 6px;
}

.admin-page-subtitle {
    color: rgba(0, 0, 0, 0.55);
    font-size: 14px;
    font-weight: 500;
}

/* Toggle Styles */
.login-mode-toggle {
    display: flex;
    background: #F5F5F5;
    padding: 4px;
    border-radius: 14px;
    margin-bottom: 30px;
}

.login-mode-toggle button {
    flex: 1 1;
    padding: 10px;
    border: none;
    background: transparent;
    color: #666;
    font-size: 14px;
    font-weight: 600;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.login-mode-toggle button.active {
    background: #fff;
    color: #FF6B35;
    color: var(--orange-primary);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

/* Form Styles */
.admin-input-group {
    margin-bottom: 20px;
}

.admin-input-group label {
    font-size: 12px;
    font-weight: 600;
    color: #444;
    margin-bottom: 8px;
    display: block;
}

.input-with-icon {
    position: relative;
    border-radius: 12px;
    background: #F9F9F9;
    border: 1px solid #E0E0E0;
    transition: all 0.3s ease;
}

.input-with-icon:focus-within {
    background: #fff;
    border-color: #FF6B35;
    border-color: var(--orange-primary);
    box-shadow: 0 0 0 4px rgba(255, 107, 53, 0.1);
}

.input-icon {
    position: absolute;
    left: 16px;
    top: 50%;
    transform: translateY(-50%);
    color: #999;
}

.input-with-icon:focus-within .input-icon {
    color: #FF6B35;
    color: var(--orange-primary);
}

.input-with-icon input {
    width: 100%;
    padding: 16px 16px 16px 48px;
    background: transparent;
    border: none;
    outline: none;
    color: #333;
    font-size: 15px;
    font-family: 'Plus Jakarta Sans', sans-serif;
}

.password-toggle {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    color: #999;
    cursor: pointer;
}

.admin-form-options {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0 25px;
}

.admin-checkbox {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #666;
    font-size: 13px;
    cursor: pointer;
}

.admin-checkbox input {
    accent-color: #FF6B35;
    accent-color: var(--orange-primary);
}

.forgot-btn {
    background: none;
    border: none;
    color: #FF6B35;
    color: var(--orange-primary);
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
}

.admin-submit-btn {
    width: 100%;
    padding: 16px;
    background: #FF6B35;
    background: var(--orange-primary);
    color: #fff;
    border: none;
    border-radius: 14px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
}

.admin-submit-btn:hover:not(:disabled) {
    background: #D84315;
    background: var(--orange-dark);
    transform: translateY(-2px);
    box-shadow: 0 10px 20px rgba(216, 67, 21, 0.2);
}

.admin-submit-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

/* OTP Input */
.otp-digit-container {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 20px;
}

.otp-digit-input {
    flex: 1 1;
    height: 60px;
    background: #F9F9F9;
    border: 1px solid #E0E0E0;
    border-radius: 12px;
    font-size: 24px;
    font-weight: 700;
    color: #FF6B35;
    color: var(--orange-primary);
    text-align: center;
}

.otp-digit-input:focus {
    border-color: #FF6B35;
    border-color: var(--orange-primary);
    outline: none;
    background: #fff;
}

.otp-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 25px;
}

.change-number-btn {
    background: #F5F5F5;
    color: #666;
    padding: 8px 12px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    border: none;
    display: flex;
    align-items: center;
    gap: 6px;
}

.resend-otp-link {
    background: none;
    border: none;
    color: #FF6B35;
    color: var(--orange-primary);
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
}

.otp-sent-message {
    background: rgba(52, 199, 89, 0.1);
    border: 1px solid rgba(52, 199, 89, 0.2);
    border-radius: 12px;
    padding: 12px;
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 20px;
}

.otp-sent-message p {
    color: #2D2D2D;
    font-size: 13px;
    margin: 0;
    font-weight: 500;
}

.otp-sent-message svg {
    color: #34c759;
}

/* Alert */
.admin-alert {
    background: #FEF2F2;
    border: 1px solid #FECACA;
    color: #DC2626;
    padding: 12px;
    border-radius: 10px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 13px;
    font-weight: 500;
}

/* Footer & Legal */
.admin-card-footer {
    margin-top: 30px;
    padding-top: 20px;
    border-top: 1px solid #F0F0F0;
    display: flex;
    justify-content: center;
}

.security-tag {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #999;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 1px;
}

.admin-legal-notice {
    margin-top: 20px;
    text-align: center;
}

.admin-legal-notice p {
    color: #AAA;
    font-size: 11px;
}

/* Responsive */
@media (max-width: 900px) {
    .admin-login-container {
        flex-direction: column;
        max-width: 500px;
        min-height: auto;
    }

    .admin-login-visual {
        display: none;
        /* Hide visual on mobile or make it smaller */
    }

    .admin-login-form-container {
        padding: 40px 20px;
    }
}

.admin-spinner {
    width: 18px;
    height: 18px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-top-color: currentColor;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/AdminLoginPage.css"],"names":[],"mappings":"AAAA;;qCAEqC;;AAIrC;IACI,uBAAuB;IACvB,yBAAyB;IACzB,sBAAsB;IACtB,sCAAsC;IACtC,mBAAmB;IACnB,oCAAoC;IACpC,uCAAuC;AAC3C;;AAEA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,iCAAiC;IACjC,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,0CAA0C;IAC1C,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;;qCAEqC;AACrC;IACI,SAAO;IACP,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,2BAA2B;IAC3B,UAAU;IACV,kCAAkC;IAClC,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,aAAa;IACb,UAAU;AACd;;AAEA;IACI,UAAU;IACV,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,2GAA2G;IAC3G,WAAW;AACf;;AAEA;IACI,WAAW;IACX,UAAU;IACV,gCAAgC;AACpC;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oCAAoC;IACpC,YAAY;IACZ,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;;AAEA;;qCAEqC;AACrC;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;AACpB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,cAA4B;IAA5B,4BAA4B;IAC5B,0CAA0C;AAC9C;;AAEA,gBAAgB;AAChB;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,qBAAmC;IAAnC,mCAAmC;IACnC,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,cAA4B;IAA5B,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,4BAA4B;IAC5B,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,eAAe;IACf,4CAA4C;AAChD;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,qBAAmC;IAAnC,mCAAmC;AACvC;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAA4B;IAA5B,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAiC;IAAjC,iCAAiC;IACjC,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,mBAA8B;IAA9B,8BAA8B;IAC9B,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,cAAc;AACd;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAA4B;IAA5B,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,qBAAmC;IAAnC,mCAAmC;IACnC,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAA4B;IAA5B,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kCAAkC;IAClC,wCAAwC;IACxC,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA,UAAU;AACV;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB;IACI,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;IAC7B,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA,eAAe;AACf;IACI;QACI,sBAAsB;QACtB,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,6CAA6C;IACjD;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,8BAA8B;IAC9B,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ","sourcesContent":["/* ================================\n   ADMIN LOGIN PAGE - SPLIT LAYOUT\n   ================================ */\n\n@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');\n\n:root {\n    --orange-light: #FF9966;\n    --orange-primary: #FF6B35;\n    --orange-dark: #D84315;\n    --orange-glow: rgba(255, 107, 53, 0.4);\n    --bg-light: #FFF5F0;\n    --card-bg: rgba(255, 255, 255, 0.95);\n    --glass-border: rgba(255, 107, 53, 0.2);\n}\n\n* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\n.admin-login-page {\n    min-height: 100vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #FFF5F0;\n    font-family: 'Outfit', sans-serif;\n    padding: 20px;\n}\n\n.admin-login-container {\n    display: flex;\n    width: 100%;\n    max-width: 1200px;\n    background: #fff;\n    border-radius: 32px;\n    box-shadow: 0 30px 60px rgba(0, 0, 0, 0.1);\n    overflow: hidden;\n    min-height: 700px;\n}\n\n/* ================================\n   LEFT SIDE: VISUAL CAROUSEL\n   ================================ */\n.admin-login-visual {\n    flex: 1;\n    position: relative;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    background: #000;\n}\n\n.carousel-track {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n\n.carousel-slide {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-size: cover;\n    background-position: center;\n    opacity: 0;\n    transition: opacity 1s ease-in-out;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    padding: 60px;\n    z-index: 1;\n}\n\n.carousel-slide.active {\n    opacity: 1;\n    z-index: 2;\n}\n\n.slide-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(to top, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.2) 50%, rgba(0, 0, 0, 0.1) 100%);\n    z-index: -1;\n}\n\n.slide-content {\n    color: #fff;\n    z-index: 3;\n    animation: slideUp 0.8s ease-out;\n}\n\n@keyframes slideUp {\n    from {\n        opacity: 0;\n        transform: translateY(20px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.slide-content h2 {\n    font-size: 36px;\n    font-weight: 700;\n    margin-bottom: 12px;\n    line-height: 1.2;\n}\n\n.slide-content p {\n    font-size: 16px;\n    opacity: 0.9;\n    line-height: 1.6;\n    max-width: 80%;\n}\n\n.carousel-indicators {\n    position: absolute;\n    bottom: 30px;\n    right: 30px;\n    display: flex;\n    gap: 8px;\n    z-index: 10;\n}\n\n.indicator {\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    background: rgba(255, 255, 255, 0.3);\n    border: none;\n    cursor: pointer;\n    transition: all 0.3s ease;\n}\n\n.indicator.active {\n    background: #fff;\n    width: 30px;\n    border-radius: 10px;\n}\n\n/* ================================\n   RIGHT SIDE: LOGIN FORM\n   ================================ */\n.admin-login-form-container {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 60px;\n    background: #fff;\n    position: relative;\n}\n\n.admin-login-card {\n    width: 100%;\n    max-width: 420px;\n}\n\n.admin-login-logo {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 24px;\n}\n\n.admin-login-logo img {\n    height: 60px;\n    width: auto;\n}\n\n.admin-login-header {\n    text-align: center;\n    margin-bottom: 30px;\n}\n\n.admin-page-title {\n    font-size: 28px;\n    font-weight: 700;\n    color: #2D2D2D;\n    margin-bottom: 6px;\n}\n\n.admin-page-subtitle {\n    color: rgba(0, 0, 0, 0.55);\n    font-size: 14px;\n    font-weight: 500;\n}\n\n/* Toggle Styles */\n.login-mode-toggle {\n    display: flex;\n    background: #F5F5F5;\n    padding: 4px;\n    border-radius: 14px;\n    margin-bottom: 30px;\n}\n\n.login-mode-toggle button {\n    flex: 1;\n    padding: 10px;\n    border: none;\n    background: transparent;\n    color: #666;\n    font-size: 14px;\n    font-weight: 600;\n    border-radius: 12px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n}\n\n.login-mode-toggle button.active {\n    background: #fff;\n    color: var(--orange-primary);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n}\n\n/* Form Styles */\n.admin-input-group {\n    margin-bottom: 20px;\n}\n\n.admin-input-group label {\n    font-size: 12px;\n    font-weight: 600;\n    color: #444;\n    margin-bottom: 8px;\n    display: block;\n}\n\n.input-with-icon {\n    position: relative;\n    border-radius: 12px;\n    background: #F9F9F9;\n    border: 1px solid #E0E0E0;\n    transition: all 0.3s ease;\n}\n\n.input-with-icon:focus-within {\n    background: #fff;\n    border-color: var(--orange-primary);\n    box-shadow: 0 0 0 4px rgba(255, 107, 53, 0.1);\n}\n\n.input-icon {\n    position: absolute;\n    left: 16px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: #999;\n}\n\n.input-with-icon:focus-within .input-icon {\n    color: var(--orange-primary);\n}\n\n.input-with-icon input {\n    width: 100%;\n    padding: 16px 16px 16px 48px;\n    background: transparent;\n    border: none;\n    outline: none;\n    color: #333;\n    font-size: 15px;\n    font-family: 'Plus Jakarta Sans', sans-serif;\n}\n\n.password-toggle {\n    position: absolute;\n    right: 16px;\n    top: 50%;\n    transform: translateY(-50%);\n    background: none;\n    border: none;\n    color: #999;\n    cursor: pointer;\n}\n\n.admin-form-options {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin: 10px 0 25px;\n}\n\n.admin-checkbox {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    color: #666;\n    font-size: 13px;\n    cursor: pointer;\n}\n\n.admin-checkbox input {\n    accent-color: var(--orange-primary);\n}\n\n.forgot-btn {\n    background: none;\n    border: none;\n    color: var(--orange-primary);\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n}\n\n.admin-submit-btn {\n    width: 100%;\n    padding: 16px;\n    background: var(--orange-primary);\n    color: #fff;\n    border: none;\n    border-radius: 14px;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n}\n\n.admin-submit-btn:hover:not(:disabled) {\n    background: var(--orange-dark);\n    transform: translateY(-2px);\n    box-shadow: 0 10px 20px rgba(216, 67, 21, 0.2);\n}\n\n.admin-submit-btn:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n/* OTP Input */\n.otp-digit-container {\n    display: flex;\n    justify-content: space-between;\n    gap: 10px;\n    margin-bottom: 20px;\n}\n\n.otp-digit-input {\n    flex: 1;\n    height: 60px;\n    background: #F9F9F9;\n    border: 1px solid #E0E0E0;\n    border-radius: 12px;\n    font-size: 24px;\n    font-weight: 700;\n    color: var(--orange-primary);\n    text-align: center;\n}\n\n.otp-digit-input:focus {\n    border-color: var(--orange-primary);\n    outline: none;\n    background: #fff;\n}\n\n.otp-actions {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 25px;\n}\n\n.change-number-btn {\n    background: #F5F5F5;\n    color: #666;\n    padding: 8px 12px;\n    border-radius: 8px;\n    font-size: 12px;\n    font-weight: 600;\n    cursor: pointer;\n    border: none;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.resend-otp-link {\n    background: none;\n    border: none;\n    color: var(--orange-primary);\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n}\n\n.otp-sent-message {\n    background: rgba(52, 199, 89, 0.1);\n    border: 1px solid rgba(52, 199, 89, 0.2);\n    border-radius: 12px;\n    padding: 12px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 20px;\n}\n\n.otp-sent-message p {\n    color: #2D2D2D;\n    font-size: 13px;\n    margin: 0;\n    font-weight: 500;\n}\n\n.otp-sent-message svg {\n    color: #34c759;\n}\n\n/* Alert */\n.admin-alert {\n    background: #FEF2F2;\n    border: 1px solid #FECACA;\n    color: #DC2626;\n    padding: 12px;\n    border-radius: 10px;\n    margin-bottom: 20px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    font-size: 13px;\n    font-weight: 500;\n}\n\n/* Footer & Legal */\n.admin-card-footer {\n    margin-top: 30px;\n    padding-top: 20px;\n    border-top: 1px solid #F0F0F0;\n    display: flex;\n    justify-content: center;\n}\n\n.security-tag {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    color: #999;\n    font-size: 11px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n}\n\n.admin-legal-notice {\n    margin-top: 20px;\n    text-align: center;\n}\n\n.admin-legal-notice p {\n    color: #AAA;\n    font-size: 11px;\n}\n\n/* Responsive */\n@media (max-width: 900px) {\n    .admin-login-container {\n        flex-direction: column;\n        max-width: 500px;\n        min-height: auto;\n    }\n\n    .admin-login-visual {\n        display: none;\n        /* Hide visual on mobile or make it smaller */\n    }\n\n    .admin-login-form-container {\n        padding: 40px 20px;\n    }\n}\n\n.admin-spinner {\n    width: 18px;\n    height: 18px;\n    border: 2px solid rgba(255, 255, 255, 0.3);\n    border-top-color: currentColor;\n    border-radius: 50%;\n    animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
